import {queryGraphQL} from 'common/util/query';
import {
    node,
    nodeWithArgs,
    toQuery,
    toMutation
} from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import lodash from 'lodash';

export const PROCESS_LOAD_TASK = 'PROCESS_LOAD_TASK';
export const REGISTRATION_COMPLETE = 'REGISTRATION_COMPLETE';
export const TASK_ACTION_COMPLETE = 'TASK_ACTION_COMPLETE';
export const LOAD_TRAINING_CONTENT = 'LOAD_TRAINING_CONTENT';

export function loadCurrentRegistrationStep(){
    const query = toQuery(node('me', [
        'hasCompletedRegistration',
        nodeWithArgs('currentTaskStep', {
            type: 'registration'
        }, [
            node('task', ['id']),
            node('step', [
                'id',
                node('state', [
                    'id',
                    'dataFields',
                    'displayName',
                    node('action', [
                        'id',
                        'name',
                        'type'
                    ])
                ])
            ]),
            'content'
        ])
    ]));

    return dispatch => queryGraphQL(query)
        .then(results => {
            if(results.errors){
                return dispatch(addApplicationMessage('warning', 'There was an issue loading the registration process'));
            }

            const { data } = results;
            if(lodash.get(data, 'me.hasCompletedRegistration', false)){
                return dispatch(registrationComplete());
            }

            return dispatch({
                type: PROCESS_LOAD_TASK,
                payload: data
            });
        });
}

export function registrationComplete(){
    return {
        type: REGISTRATION_COMPLETE
    };
}

export function completeTaskAction(taskId, actionId, data){
    data = JSON.stringify(data);
    const mutation = toMutation(nodeWithArgs('completeTaskAction', {
        input: {
            taskId,
            actionId,
            data
        }
    }, [
        node('task', ['id']),
        node('step', [
            'id',
            node('state', [
                'id',
                'dataFields',
                'displayName',
                node('action', [
                    'id',
                    'name',
                    'type'
                ])
            ])
        ]),
        'content'
    ]));

    return dispatch => queryGraphQL(mutation)
        .then(results => {
            if(results.errors){
                return dispatch(addApplicationMessage('warning', 'There was an issue completing this step. Please try again.'));
            }

            const { data } = results;
            return dispatch({
                type: TASK_ACTION_COMPLETE,
                payload: data
            });
        });
}

